import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';

@Component({
    selector: 'isophi-app-portfolio-plan-planned',
    templateUrl: './portfolio-plan-planned.component.html',
    styleUrls: ['./portfolio-plan-planned.component.scss'],
    standalone: false
})
export class PortfolioPlanPlannedComponent implements OnInit {
  @Input()
  plannedActivities: string[] = [];
  @Input()
  allowEditMode = true;

  @Output()
  requestSave$ = new EventEmitter<string[]>();

  private readonly formBuilder = inject(FormBuilder);

  form = this.formBuilder.group({
    plannedActivities: new FormArray<FormControl<string>>([]),
  });

  ngOnInit(): void {
    this.plannedActivities.forEach((activity) => {
      this.form.controls.plannedActivities.push(new FormControl(activity));
    });
  }

  addPlannedActivity(): void {
    this.form.controls.plannedActivities.push(new FormControl(''));
  }

  removePlannedActivity(index: number): void {
    this.form.controls.plannedActivities.removeAt(index);
  }

  cancel(): void {
    this.form.controls.plannedActivities.clear();
    this.plannedActivities.forEach((activity) => {
      this.form.controls.plannedActivities.push(new FormControl(activity));
    });
  }

  save(): void {
    this.plannedActivities = this.form.controls.plannedActivities.value;
    this.requestSave$.emit(this.form.controls.plannedActivities.value);
  }
}
